import { get, put } from './Tools';

const getConfig = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}configuracion_aplicacion`);
  return response;
};

const getEmitEnv = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}configuracion_aplicacion/env`);
  return response;
};

const saveConfig = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}configuracion_aplicacion`, payload);
  return response;
};

export { getConfig, saveConfig, getEmitEnv };
